import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useStyles } from "./HomePageHeaderStyle";
import Buttons from "../Buttons/Buttons";
import LanguageDropdown from "../LanguageDropdown/LanguageDropdown";
import AnchorLink from "react-anchor-link-smooth-scroll";
import ResponsiveNavbar from "./ResposiveNavbar";
import { useLocation, useNavigate } from "react-router-dom";

const HomePageHeader = () => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const [showMenu, setShowMenu] = useState(false);

  const handleNavigate = (type) => {
    setShowMenu(false);
    if (type === "transport") {
      window.open("https://travelbim.com", "_blank", "noopener,noreferrer");
    } else if (type === "industry") {
      window.open("https://www.sonabim-industry.com/", "_blank");
    }
  };

  return (
    <Box className={classes.HeaderMainContainer}>
      <div data-aos="zoom-in-down" data-aos-delay="500">
        <img
          src="SoonabimLogo.png"
          alt=""
          onMouseEnter={() => window.location.reload()}
          className={classes.WebsiteLogo}
        />
      </div>

      <Box className={classes.HeaderSubWrapper}>
        {isHomePage && (
          <div data-aos="zoom-in-left" data-aos-delay="500">
            <Box className={classes.ListWrapper}>
              <Box
                onMouseEnter={() => setShowMenu(true)}
                onMouseLeave={() => setShowMenu(false)}
                style={{ position: "relative" }}
              >
                <Typography variant="h6" className={classes.ListItemText}>
                  Votre Activité
                </Typography>

                <Box
                  className={classes.menuContainer}
                  style={{
                    display: showMenu ? "block" : "none",
                    position: "absolute",
                    top: "100%",
                    left: "-25px",
                    backgroundColor: "#49A995",
                    padding: "10px 0",
                    borderRadius: "4px",
                    zIndex: 999,
                    minWidth: "200px",
                  }}
                >
                  <Typography
                    className={classes.menuItem}
                    onClick={() => handleNavigate("transport")}
                  >
                    Transport & Mobilités
                  </Typography>
                  <Typography
                    className={classes.menuItem}
                    onClick={() => handleNavigate("industry")}
                  >
                    Production Industrielle
                  </Typography>
                </Box>
              </Box>
            </Box>
          </div>
        )}

        <div data-aos="zoom-in-left" data-aos-delay="500">
          <AnchorLink
            href="#contactez-nous"
            offset="100"
            className={classes.NavContactUsButtons}
          >
            <Buttons
              Title="Contactez-nous"
              className={classes.ContactUsButton}
            />
          </AnchorLink>
        </div>

        <div data-aos="zoom-in-left" data-aos-delay="500">
          <LanguageDropdown />
        </div>

        <Box className={classes.ResponsiveNavbar}>
          <ResponsiveNavbar />
        </Box>
      </Box>
    </Box>
  );
};

export default HomePageHeader;
